import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { StorageLocationsStore } from '../utility/signal-stores/storage-locations.store';

export const storageLocationsResolver: ResolveFn<void> = () => {
  const storageLocationsStore = inject(StorageLocationsStore);
  return storageLocationsStore.load();
};
